<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">General Settings - Feature ON/OFF</h5>
      <br />
    </div>
    <b-row>
      <b-col md="6">
        <b-card class="text-left">
          <b>Create New Feature ON/OFF</b>
          <b-row class="mt-4">
            <b-col md="12">
              <b-form-group
                id="fieldset-1"
                label="Display Name"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="display_name"
                  name="display_name"
                  data-vv-as="Display Name"
                  id="input-1"
                  class="form-control"
                  placeholder="Display Name"
                />
                <b-form-invalid-feedback
                  id="input-display_name-feedback"
                >{{ veeErrors.first('display_name') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group
                id="fieldset-1"
                label="Description"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <ckeditor
                  :editor="editor"
                  tag-name="textarea"
                  placeholder="Description"
                  v-model="description"
                  v-validate="'required'"
                  name="description"
                  data-vv-as="Description"
                  class="form-control"
                  :config="editorConfig"
                ></ckeditor>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('description') }}</p>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group
                id="fieldset-1"
                label="Value"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <b-form-select
                  v-model="value"
                  v-validate="'required'"
                  name="value"
                  data-vv-as="Value"
                  :options="options"
                  class="mb-3"
                ></b-form-select>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('value') }}</p>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row class="text-right">
            <b-col md="4" class="text-left">
              <label class="text-danger">
                *
                <b class="text-dark">Required</b>
              </label>
            </b-col>
            <b-col>
              <b-button
                variant="primary"
                :disabled="loading"
                @click="post()"
                class="mr-3"
                size="lg"
              >
                Create
                <b-spinner v-if="loading" small label="Loading..."></b-spinner>
              </b-button>
              <router-link :to="{name: 'GeneralEnableDisableFeature'}">
                <b-button variant="outline-secondary" size="lg">Cancel</b-button>
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      loading: false,
      display_name: null,
      value: null,
      selected: null,
      description: null,
      options: [
        { value: null, text: "Pick one Value", disabled: true },
        { value: "enabled", text: "Enabled" },
        { value: "disabled", text: "Disabled" }
      ]
    };
  },
  methods: {
    post() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("display_name", this.display_name);
          formData.append("description", this.description);
          formData.append("value", this.value);
          this.$store
            .dispatch(
              "GeneralSettingsModule/postEnableDisableFeature",
              formData
            )
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "GeneralEnableDisableFeature" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data,
                showConfirmButton: false,
                timer: 1500
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your file cant be submit.", "warning");
        }
      });
    },
    onChangeimage() {
      this.image = this.$refs.image.files[0];
      const input = this.$refs.image;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  }
};
</script>

<style>
</style>
